import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // Array of critical API requests that must complete before rendering
  criticalRequests: [],
  // Whether all critical requests are complete
  isAppReady: false,
  // General loading flag
  isLoading: false,
  // Message shown to the user
  loadingMessage: 'Loading...'
}

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    // Add a critical request to the pending list
    addCriticalRequest: (state, action) => {
      const { requestId, description } = action.payload
      const existingRequest = state.criticalRequests.find(req => req.id === requestId)
      
      if (!existingRequest) {
        state.criticalRequests.push({
          id: requestId,
          description: description || 'Loading...',
          status: 'pending' // pending, success, error
        })
        state.isLoading = true
        state.isAppReady = false
      }
    },
    
    // Mark a critical request as complete
    completeCriticalRequest: (state, action) => {
      const { requestId, status = 'success' } = action.payload
      const request = state.criticalRequests.find(req => req.id === requestId)
      
      if (request) {
        request.status = status
      }
      
      // Check if all critical requests are complete
      const allCompleted = state.criticalRequests.every(req => req.status !== 'pending')
      if (allCompleted) {
        state.isAppReady = true
        state.isLoading = false
      }
    },
    
    // Remove a critical request from the list
    removeCriticalRequest: (state, action) => {
      const requestId = action.payload
      state.criticalRequests = state.criticalRequests.filter(req => req.id !== requestId)
      
      // If no critical requests left, app is ready
      if (state.criticalRequests.length === 0) {
        state.isAppReady = true
        state.isLoading = false
      }
    },
    
    // Reset loading state
    resetLoading: (state) => {
      state.criticalRequests = []
      state.isAppReady = false
      state.isLoading = false
      state.loadingMessage = 'Loading...'
    },
    
    // Set loading message
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload
    },
    
    // Force app ready state
    setAppReady: (state, action) => {
      state.isAppReady = action.payload
      if (action.payload) {
        state.isLoading = false
      }
    }
  }
})

export const {
  addCriticalRequest,
  completeCriticalRequest,
  removeCriticalRequest,
  resetLoading,
  setLoadingMessage,
  setAppReady
} = loadingSlice.actions

export default loadingSlice.reducer
